/* eslint-disable react/prop-types */
/* eslint-disable react/no-danger */
/* eslint-disable react/button-has-type */
 
const optionLabels = ["A", "B", "C", "D", "E", "F"];
 
export default function PassageQuestion({question,selectedAnswer,currentIndex,onSelect,onClear}) {
  if (!question) return null;
 
  let parsedOptions = [];
 
  try {
    const parsed =
      typeof question?.options === "string"
        ? JSON.parse(question.options)
        : question.options;
 
    parsedOptions = parsed?.mcqOptions || parsed || [];
  } catch {
    parsedOptions = [];
  }
 
  const handleSelect = (opt) => {
    onSelect(opt);
  };
 
  return (
    <div style={styles.outerCard}>
      <style>{`
        .pq-split {
          display: flex;
          height: calc(100vh - 190px);
        }
        .pq-left, .pq-right {
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
        }
        @media (max-width: 767px) {
          .pq-split {
            flex-direction: column;
            height: auto;
          }
          .pq-left, .pq-right {
            width: 100% !important;
            height: auto;
            overflow: visible;
          }
          .pq-left {
            border-right: none !important;
            border-bottom: 1px solid #e5e7eb;
          }
          .pq-divider {
            display: none;
          }
        }
      `}</style>

      <div className="pq-split" style={styles.splitLayoutBase}>
        <div className="pq-left" style={styles.leftPanel}>
          <div style={styles.passageLabel}>Passage</div>
          <div style={styles.passageText} dangerouslySetInnerHTML={{__html: question?.passage_text || question?.passage || ""}}/>
        </div>

        <div className="pq-divider" style={styles.divider} />
        <div className="pq-right" style={styles.rightPanel}>
          <span style={{ fontSize: "17px", fontWeight: 700, color: "#111827", letterSpacing: "-0.01em" }}>
            Question {currentIndex + 1}
          </span>
          <div style={styles.questionText} dangerouslySetInnerHTML={{ __html: question?.question_text }} />
          <div style={styles.options}>
            {parsedOptions.map((opt, idx) => {
              const isSelected = selectedAnswer === opt;
              return (
                <button key={idx} onClick={() => handleSelect(opt,idx)} style={{...styles.optionBtn,border: isSelected ? "2px solid #1D4ED8" : "2px solid #e5e7eb", background: isSelected ? "#EFF6FF" : "#fff"}}>
                  <span style={{...styles.optionLabel,background: isSelected ? "#1D4ED8" : "#f3f4f6",color: isSelected ? "#fff" : "#6b7280"}}>
                    {optionLabels[idx]}
                  </span>
                  <span style={styles.optionText} dangerouslySetInnerHTML={{ __html: opt }}/>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
 
const styles = {
  outerCard: {
    background: "#fff",
    borderRadius: "16px",
    boxShadow: "0 4px 30px rgba(0,0,0,0.08)",
    width: "100%",
    maxWidth: "100%",
    margin: 0,
    overflow: "visible",
  },

  splitLayoutBase: {},

  leftPanel: {
    width: "40%",
    flexShrink: 0,
    padding: "1.5rem",
    background: "#f8fafc",
    borderRight: "1px solid #e5e7eb",
  },
 
  passageLabel: {
    fontSize: "0.75rem",
    fontWeight: 700,
    letterSpacing: "0.1em",
    color: "#9ca3af",
    marginBottom: "0.75rem"
  },
 
  passageText: {
    fontSize: "0.9rem",
    color: "#4b5563",
    lineHeight: 1.75,
  },
 
  divider: {
    width: "0.5px",
    background: "#e5e7eb",
  },

  rightPanel: {
    flex: 1,
    padding: "1.5rem",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    minHeight: 0,
  },
 
  questionText: {
    fontSize: "1.05rem",
    color: "#111827",
    fontWeight: 600,
    lineHeight: 1.6,
  },
 
  options: {
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
  },
 
  optionBtn: {
    display: "flex",
    alignItems: "center",
    gap: "0.85rem",
    padding: "0.85rem 1rem",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "all 0.15s ease",
    outline: "none",
    textAlign: "left",
    background: "#fff",
  },
 
  optionLabel: {
    width: "32px",
    height: "32px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: "0.85rem",
    flexShrink: 0,
  },
 
  optionText: {
    fontSize: "0.95rem",
    color: "#374151",
    flex: 1,
  },
};
 